// src/screens/PortalShell.jsx
import { useState } from "react";
import { C, globalStyles } from "../styles/tokens";
import Sidebar   from "../components/Sidebar";
import Topbar    from "../components/Topbar";
import DashboardScreen  from "./DashboardScreen";
import InventoryScreen  from "./InventoryScreen";
import RequestsScreen   from "./RequestsScreen";
import DonorsScreen     from "./DonorsScreen";
import ProfileScreen    from "./ProfileScreen";
import SettingsScreen   from "./SettingsScreen";

const PAGE_META = {
  dashboard: ["Dashboard",       "City General Hospital · Blood Bank"],
  inventory: ["Blood Inventory", "Manage stock levels"],
  requests:  ["Blood Requests",  "Track and manage all requests"],
  donors:    ["Donor Directory", "Nearby registered donors"],
  profile:   ["Hospital Profile","Manage your hospital info"],
  settings:  ["Settings",        "Configure portal preferences"],
};

export default function PortalShell({ onLogout }) {
  const [active,   setActive]   = useState("dashboard");
  const [sideOpen, setSideOpen] = useState(false);
  const [showNew,  setShowNew]  = useState(false);

  const [title, subtitle] = PAGE_META[active] || ["", ""];

  const renderScreen = () => {
    switch (active) {
      case "dashboard": return <DashboardScreen setActive={setActive} />;
      case "inventory": return <InventoryScreen />;
      case "requests":  return <RequestsScreen showNew={showNew} setShowNew={setShowNew} />;
      case "donors":    return <DonorsScreen />;
      case "profile":   return <ProfileScreen />;
      case "settings":  return <SettingsScreen />;
      default:          return <DashboardScreen setActive={setActive} />;
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <style>{globalStyles}</style>

      {/* Mobile overlay */}
      {sideOpen && (
        <div
          onClick={() => setSideOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 40 }}
        />
      )}

      <Sidebar
        active={active}
        setActive={(s) => { setActive(s); setSideOpen(false); }}
        onLogout={onLogout}
        open={sideOpen}
      />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <Topbar
          title={title}
          subtitle={subtitle}
          onMenu={() => setSideOpen(!sideOpen)}
        />
        <div style={{ flex: 1, overflowY: "auto" }}>
          {renderScreen()}
        </div>
      </div>
    </div>
  );
}